module.exports = __webpack_public_path__ + "static/img/Bachelor_010341.6627081.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010341.jpg
// module id = 151
// module chunks = 0